import { Link } from "react-router-dom";
import { FooterStoreContacts, hasStoreContact } from "@/components/StoreContacts.jsx";
import BrandMark from "@/components/BrandMark.jsx";
import { STORE_LEGAL_NAME, TERMS_ROUTE } from "@/utils/constants.js";
import { useStoreInfo } from "@/store/StoreInfoContext.jsx";
import "./footer.css";

export default function Footer() {
    const { storeInfo } = useStoreInfo();
    const year = new Date().getFullYear();
    const appVersion = storeInfo?.appVersion;
    const legalName = storeInfo?.legalName?.trim() || STORE_LEGAL_NAME;

    return (
        <footer className="site-footer">
            <div className="container footer-inner">
                <div className="footer-brand">
                    <BrandMark name={legalName} />
                </div>
                {hasStoreContact(storeInfo) ? (
                    <FooterStoreContacts storeInfo={storeInfo} />
                ) : null}
                <div className="footer-bottom">
                    <p className="footer-legal">
                        © {year} {legalName}.{" "}
                        <Link to={TERMS_ROUTE}>Mentions légales et conditions générales</Link>
                    </p>
                    {appVersion && (
                        <p className="footer-app-version" title="Version de l'application">
                            v{appVersion}
                        </p>
                    )}
                </div>
            </div>
        </footer>
    );
}
